module.exports = __webpack_public_path__ + "static/img/cta-btn.5fbb70a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/c23/cta-btn.png
// module id = DI2n
// module chunks = 0